import { getProductsUrl } from "./stripeConfig";

/**
 * Fetch active products/prices from the same HTTP endpoint as Subscribe (Stripe-backed).
 * Maps to the shape expected by ProductCard / join flows (identifier = price id for checkout).
 */
export async function fetchStripeCatalogProducts() {
  try {
    const res = await fetch(getProductsUrl());
    const data = await res.json();
    const list = Array.isArray(data?.products) ? data.products : [];
    return list
      .filter((p) => p?.default_price)
      .map((p) => ({
        identifier: p.default_price,
        title: p.name || "",
        description: p.description || "",
        localizedPrice: p.price || "",
        pricePerMonthString: p.price ? `${p.price} / month` : "",
      }));
  } catch (e) {
    console.warn("fetchStripeCatalogProducts:", e);
    return [];
  }
}
